import { NormalizedProduct } from '@ravago/shared/page-data/models/contentful-mapped';

export async function getContentfulProductsByIds(locale: string, productIds: string[]): Promise<Array<NormalizedProduct> | undefined> {
  const response = await fetch(`/api/orders/products?locale=${locale}&ids=${productIds.join(',')}`);
  const data = await response.json();
  return data;
}
